define('module/ReviewModule',['require','marionette','collection/ReviewCollection','model/ReviewModel','model/ReviewClientModel','view/module/review/ReviewListModuleView','view/module/review/ReviewFormModuleView','lib/plugin/PluginBroker','lib/WindowMessageListener'],function (require) {

    var Marionette = require('marionette');
    var ReviewCollection = require('collection/ReviewCollection');
    var ReviewModel = require('model/ReviewModel');
    var ReviewClientModel = require('model/ReviewClientModel');
    var ReviewListModuleView = require('view/module/review/ReviewListModuleView');
    var ReviewFormModuleView = require('view/module/review/ReviewFormModuleView');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var WindowMessageListener = require('lib/WindowMessageListener');

    /**
     * Controller for reviews module
     *
     * @class ReviewModule
     */
    return Marionette.Object.extend({

        _regions: {
            reviewsList: '#sb_reviews_module',
            reviewsForm: '#sb_reviews_form_module'
        },
        _collection: null,
        _model: null,
        _clientModel: null,
        _reviewClientModel: null,
        _layout: null,

        /**
         * Inits instance
         */
        initialize: function () {
            if (Config.getInstance().getOption('feedbacks_disabled')) {
                return;
            }
            this._layout = this.getOption('layout');

            var limit = Config.getInstance().getOption('reviews_module_count');
            this._collection = new ReviewCollection();
            if(!_.isNull(limit) && parseInt(limit)>0) {
                this._collection.setLimit(limit);
            }
            this.initOpenIdAuth();

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._initView, this)
            );
        },

        /**
         * Subscribe to message window event
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.review_open_id_message) {
                if (this._reviewClientModel) {
                    this._reviewClientModel.fetch();
                }
            }
        },

        /**
         * Initializes regions and views
         *
         * @private
         */
        _initView: function () {
            _.each(this._regions, function (selector, region) {
                this._layout.addRegion(region, selector);
            }, this);

            this._initListView();
            this._initFormView();
        },

        /**
         * Initializes list view
         *
         * @private
         */
        _initListView: function () {
            if (this._layout.reviewsList && this._layout.reviewsList.$el.length) {
                this._layout.reviewsList.show(new ReviewListModuleView({
                    collection: this._collection
                }));
                this._collection.load();
            }
        },

        /**
         * Initializes form view
         *
         * @private
         */
        _initFormView: function () {
            if (this._layout.reviewsForm && this._layout.reviewsForm.$el.length) {
                if (!this._reviewClientModel) {
                    this._reviewClientModel = new ReviewClientModel();
                    this._reviewClientModel.fetch();
                }
                if (!this._clientModel) {
                    if (Config.getInstance().getPluginStatus('client_login')) {
                        var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                        this._clientModel = clientPlugin.getClientModel();
                    }
                }

                this._model = new ReviewModel();

                var view = new ReviewFormModuleView({
                    model: this._model,
                    reviewsCollection: this._collection,
                    reviewClientModel: this._reviewClientModel,
                    clientModel: this._clientModel
                });
                this.listenTo(view, 'saved', this._addReview);

                this._layout.reviewsForm.show(view);
            }
        },

        /**
         * Adds review to collection
         *
         * @private
         */
        _addReview: function () {
            this._collection.add(this._model);
            this._initFormView();
        }

    });

});
